import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { CastingHubService } from '@health-house/shared/api';
import { FocusRootComponent } from '@shareview/shared/focusable';
import { FadeInOut } from '../../animations';
import { CastLayoutComponent } from '../../components/cast-layout';
import { CastLayoutType } from '../../types';
import { FamilyCallWidgetComponent } from '../../widgets/family-call-widget';
import { HealthChartsWidgetComponent } from '../../widgets/health-charts-widget';
import { HealthRecordsWidgetComponent } from '../../widgets/health-records-widget';
import { KitchenInformationWidgetComponent } from '../../widgets/kitchen-information-widget';
import { RestaurantHeaderWidgetComponent } from '../../widgets/restaurant-header-widget';
import { RestaurantMenuWidgetComponent } from '../../widgets/restaurant-menu-widget';
import { SamsungHealthOverviewWidgetComponent } from '../../widgets/samsung-health-overview-widget';
import { SecurityCamerasWidgetComponent } from '../../widgets/security-cameras-widget';
import { VideoCallWidgetComponent } from '../../widgets/video-call-widget';

@Component({
  selector: 'hh-cast-page',
  standalone: true,
  imports: [CommonModule, CastLayoutComponent, HealthChartsWidgetComponent, KitchenInformationWidgetComponent, SamsungHealthOverviewWidgetComponent, SecurityCamerasWidgetComponent, VideoCallWidgetComponent, HealthRecordsWidgetComponent, RestaurantMenuWidgetComponent, RestaurantHeaderWidgetComponent, FamilyCallWidgetComponent],
  templateUrl: './cast-page.component.html',
  styleUrls: ['./cast-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [FadeInOut]
})
export class CastPageComponent extends FocusRootComponent implements OnInit {
  protected readonly layout$$ = signal<CastLayoutType>('layout-0');
  protected readonly widgets$$ = signal<string | null>(null);

  private readonly castingHubService = inject(CastingHubService);

  public override ngOnInit(): void {
    super.ngOnInit();

    this.subscription = this.castingHubService.changeLayout$.subscribe(change => {
      if (change.widgets.length === 1) {
        const widget = change.widgets[0];

        switch (widget.id) {
          case 'devices':
          case 'dining':
            this.layout$$.set('layout-4');
            break;

          case 'family':
            this.layout$$.set('layout-1');
            break;

          case 'telehealth':
            this.layout$$.set('layout-3-right');
            break;

          default:
            this.layout$$.set('layout-0');
            this.widgets$$.set(null);
            break;
        }

        this.widgets$$.set(widget.id);
      } else {
        this.layout$$.set('layout-0');
        this.widgets$$.set(null);
      }
    });
  }
}
